exports.api_url = process.env.REACT_APP_API_URL;
exports.dev_email = process.env.REACT_APP_DEV_EMAIL;
exports.dev_password = process.env.REACT_APP_DEV_PASSWORD;
exports.hitech_client_url = process.env.REACT_APP_HITECH_CLIENT_URL;
